<template>
    <div>
        <div class="d-flex align-items-center justify-content-between">
            <el-radio-group v-model="filters.app" size="small" class="mb-2">
                <el-radio-button :label="false">
                    <div class="d-flex align-items-center">
                        <i class="el-icon-monitor"></i>
                        <span>Desktop</span>
                    </div>
                </el-radio-button>
                <el-radio-button :label="true">
                    <div class="d-flex align-items-center">
                        <i class="el-icon-mobile"></i>
                        <span>App</span>
                    </div>
                </el-radio-button>
            </el-radio-group>

            <div class="d-flex justify-content-end">
                <el-dropdown size="mini" split-button plain @command="handleSetOrder">
                    <strong>Ordernar</strong>: {{ filters.orderBy == 'latest' ? 'Recentes' : 'Antigos' }}
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="latest">
                            <div class="d-flex align-items-center">
                                <i class="el-icon-top mr-2"></i>
                                Mais Recentes
                            </div>
                        </el-dropdown-item>

                        <el-dropdown-item command="oldest">
                            <div class="d-flex align-items-center">
                                <i class="el-icon-bottom mr-2"></i>
                                Mais Antigos
                            </div>
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>

        <el-table
            class="rounded"
            v-loading="loading"
            :data="data"
            align="center"
            border
        >
            <!-- Descrição -->
            <el-table-column label="Descrição" min-width="220" align="left">
                <template slot-scope="scope">
                    <span class="text-capitalize">{{ scope.row.descricao.toLowerCase() }}</span>
                </template>
            </el-table-column>

            <!-- Imagem -->
            <el-table-column label="Imagem" width="100" align="center" class="position-relative">
                <template slot-scope="scope">
                    <el-image 
                        :style="{
                            width: '100%',
                            height: '100%',
                            position: 'absolute',
                            inset: 0,
                        }"
                        :src="scope.row.imagem" 
                        :preview-src-list="[`${scope.row.imagem}`]"
                        fit="cover"
                    >
                        <template slot="error">
                            <div class="d-flex align-items-center justify-content-center border rounded" :style="{height: '100%'}">
                                <i class="el-icon-picture-outline"></i>
                            </div>
                        </template>
                    </el-image>
                </template>
            </el-table-column>

            <!-- Periodo de exibição -->
            <el-table-column label="Período de exibição" width="300" align="center">
                <template slot-scope="scope">
                    <div class="d-flex align-items-center justify-content-center">
                        <div class="d-flex align-itens-center" :style="{ gap: '12px' }">
                            <span v-if="scope.row.inicio_vigencia" class="ml-1">{{ formatDate(scope.row.inicio_vigencia, true) }}</span>
                            <el-tag v-else size="small" type="info" class="ml-1">INDEFINIDO</el-tag>
                            <span><strong>-</strong></span>
                            <span v-if="scope.row.fim_vigencia" class="ml-1">{{ formatDate(scope.row.fim_vigencia, true) }}</span>
                            <el-tag v-else  size="small" type="info" class="ml-1">INDEFINIDO</el-tag>
                        </div>
                    </div>
                </template>
            </el-table-column>

            <!-- Classe -->
            <el-table-column label="Classe" width="80" align="center">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.classe" size="small" type="primary">{{ scope.row.classe }}</el-tag>
                    <el-tag v-else size="small" type="success">TODAS</el-tag>
                </template>
            </el-table-column>

            <!-- Situacao -->
            <el-table-column label="Situação" width="100" align="left">
                <template slot-scope="scope">
                    <el-tag 
                        size="small"
                        :type="scope.row.ativo
                            ? 'success' 
                            : 'danger'"
                    >
                      {{ scope.row.ativo ? 'ATIVO' : 'INATIVO' }}
                    </el-tag>
                </template>
            </el-table-column>

            <!-- Criado em -->
            <el-table-column label="Criado em" width="180" align="left">
                <template slot-scope="scope">
                    <div class="d-flex align-items-center">
                        <i class="el-icon-time"></i>
                        <span class="ml-1">{{ formatDate(scope.row.created_at, true) }}</span>
                    </div>
                </template>
            </el-table-column>

            <!-- Acoes -->
            <el-table-column
              fixed="right"
              align="right"
              width="50"
            >
                <div slot="header" style="width: 100%;">
                    <i class="el-icon-menu" />
                </div>

                <template slot-scope="scope">
                    <div class="d-flex justify-content-between">
                        <el-popover placement="bottom-end" trigger="click">
                            <el-button
                                slot="reference"
                                size="mini" 
                                type="info" 
                                plain 
                                circle
                                :disabled="loading"
                            >
                                <i class="el-icon-more"></i>
                            </el-button>

                            <div :style="{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column', gap: '4px', maxWidth: '300px' }">
                                <span class="font-weight-bold">Ações</span>
                                <el-divider class="my-1"></el-divider>

                                <div :style="{ width: '100%'}">
                                    <el-button
                                        slot="reference"
                                        size="mini"
                                        type="warning"
                                        plain
                                        @click="dispatchBannerEdit(scope.row.id)"
                                        :style="{ width: '100%'}"
                                    >   
                                        <i class="el-icon-edit"></i>
                                        <span>Editar</span>
                                    </el-button>
                                </div>

                                <div :style="{ width: '100%'}">
                                    <el-button
                                        slot="reference"
                                        size="mini"
                                        type="danger"
                                        plain
                                        @click="dispatchBannerDelete(scope.row.id)"
                                        :style="{ width: '100%'}"
                                    > 
                                        <i class="el-icon-delete"></i>
                                        <span>Excluir</span>
                                    </el-button>
                                </div>
                            </div>
                        </el-popover>
                    </div>
                </template>
            </el-table-column>

            <template slot="empty">
                <el-empty description="Nenhuma banner disponível"></el-empty>
            </template>
        </el-table>

        <!-- Paginacao -->
        <el-row class="mt-3">
            <el-col>
                <el-pagination
                  background
                  :current-page.sync="pagination.data.currentPage"
                  :page-sizes="pagination.pageSizes"
                  :page-size="pagination.data.perPage"
                  layout="total, sizes, prev, pager, next"
                  :total="pagination.total"
                  @current-change="handlePageChange"
                  @size-change="handleSizeChange"
                />
            </el-col>
        </el-row>

        <!-- RevendedoraEdit -->
        <BannerEditModal ref="bannerEdit" @updated="fetch"/>

        <!-- DeleteModal -->
        <BannerDeleteModal ref="bannerDelete" @deleted="fetch"/>
    </div>
</template>

<script>
    // Components
    import CardBase from "@/components/_macro/CardBase.vue";
    import { Empty, Table, TableColumn, Notification, Popover, Tag, Divider, Image, RadioGroup, RadioButton, Dropdown, DropdownMenu, DropdownItem } from "element-ui";

    import BannerEditModal from "./BannerEditModal.vue";
    import BannerDeleteModal from "./BannerDeleteModal.vue";

    // Api
    import { BannerApi } from "@/api/BannerApi";
    const bannerApi = new BannerApi();

    // Utils
    import { formatDate } from "@/util/formatters";

    export default {
        name: "banner-list",
        data() {
            return {
                data: [],
                loading: false,
                filters: {
                    app: false,
                    orderBy: 'latest',
                },
                pagination: {
                    data: {
                        currentPage: 1,
                        perPage: 15,
                    },
                    pageSizes: [15, 50, 75, 100],
                    total: 0
                },
            }
        },
        methods: {
            async fetch() {
                try {
                    this.loading = true;

                    const res = await bannerApi.list({
                        ...this.filters,
                        ...this.pagination.data
                    });

                    this.data = res.data;
                    this.pagination.total = res.total;
                } catch (err) {
                    Notification.error({
                        title: 'Erro',
                        message: 'Não foi possível obter os banners!'
                    });
                } finally {
                    this.loading = false;
                }
            },
            /**
             * Editar
             */
            async dispatchBannerEdit(id) {
                this.$refs.bannerEdit.id = id;

                const elLoading = this.$loading({ lock: true })

                await this.$refs.bannerEdit.show();

                elLoading.close();

                return this.$refs.bannerEdit.toggleModal();
            },

            /** Excluir */
            async dispatchBannerDelete(id) {
                this.$refs.bannerDelete.id = id;

                const elLoading = this.$loading({ lock: true })

                await this.$refs.bannerDelete.show();

                elLoading.close();

                return this.$refs.bannerDelete.toggleModal();
            },

            /**
             * Filters 
             */
            async handleSetOrder(orderBy) {
                this.filters.orderBy = orderBy;
            },

            /*
            * Pagination 
            *
            */
            handlePageChange(page) {
                this.pagination.data.currentPage = page;
                this.fetch();
            },
            handleSizeChange(val) {
                this.pagination.data.perPage = val;
                this.pagination.data.currentPage = 1;
                this.fetch();
            },
            /** Utils */
            formatDate
        },
        watch: {
            "filters": {
                deep: true,
                handler() {
                    this.pagination.data.currentPage = 1;
                    this.fetch();
                },
            }
        },
        mounted() {
            this.fetch();
        },
        components: {
            CardBase,
            [Empty.name]: Empty,
            [Table.name]: Table,
            [TableColumn.name]: TableColumn,
            [Notification.name]: Notification,
            [Tag.name]: Tag,
            [Divider.name]: Divider,
            [Image.name]: Image,
            [RadioGroup.name]: RadioGroup,
            [RadioButton.name]: RadioButton,
            [Dropdown.name]: Dropdown,
            [DropdownMenu.name]: DropdownMenu,
            [DropdownItem.name]: DropdownItem,
            BannerDeleteModal,
            BannerEditModal,
        },
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/_macro/banner/BannerList.vue